import { scoreColor } from "@/lib/format";

export function ScoreRing({ score = 0, max = 100, size = 128, stroke = 12, label = "Overall", color, suffix, testId = "overall-score-ring" }) {
  const r = (120 - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, ((score || 0) / (max || 100)) * 100));
  const offset = c - (c * pct) / 100;
  const ringColor = color || scoreColor(score);
  return (
    <div className="relative inline-grid place-items-center" style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} viewBox="0 0 120 120" className="-rotate-90">
        <circle cx="60" cy="60" r={r} stroke="#E6E9EF" strokeWidth={stroke} fill="none" />
        <circle
          cx="60" cy="60" r={r} stroke={ringColor} strokeWidth={stroke} fill="none"
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.9s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="flex items-baseline font-display font-semibold leading-none text-foreground">
          <span style={{ fontSize: size * 0.28 }}>{Math.round(score)}</span>
          {suffix && <span className="text-muted-foreground" style={{ fontSize: size * 0.14 }}>{suffix}</span>}
        </span>
        {label && <span className="mt-1 text-[10px] uppercase tracking-wide text-muted-foreground">{label}</span>}
      </div>
    </div>
  );
}
